/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-03-14 11:47:19
 * @LastEditors: 刘洪壮 liuhongzhuang@nextmar.com
 * @LastEditTime: 2025-05-09 13:24:49
 * @FilePath: /zeelool-nextjs/src/components/Button/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  ButtonProps,
  Button as MuiButton,
  useMediaQuery,
  useTheme as useMuiTheme,
} from '@mui/material';

export interface CustomButtonProps extends ButtonProps {
  radiusSize?: 'small' | 'medium' | 'large';
  // TODO: 神策上报事件放在这里统一处理
}

const radiusSizeMap = {
  small: '4px',
  medium: '12px', // UI暂未定义
  large: '20px',
};

const Button = ({ radiusSize, sx, ...props }: CustomButtonProps) => {
  const theme = useMuiTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const defaultRadiusSize = isMobile ? 'large' : 'small';

  return (
    <MuiButton
      sx={{
        borderRadius: radiusSize ? radiusSizeMap[radiusSize] : radiusSizeMap[defaultRadiusSize],
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none',
        },
        '&.MuiButton-contained.Mui-disabled': {
          color: 'white',
        },
        ...sx,
      }}
      {...props}
    />
  );
};

export default Button;
